import { useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Select } from 'shared/ui/Select/Select'
import { availableHeight } from 'shared/lib'
import { type FiltersStore } from 'pages/conversations/pages/calls/ui/CallHistoryDropdownFilter'
import { getFiltersItems } from 'pages/conversations/pages/calls/ui/CallHistoryDropdownFilter/store/config'

type ICallHistoryDropdownFilterProps = {
  store: FiltersStore
}

export const CallHistoryDropdownFilter: FC<ICallHistoryDropdownFilterProps> = observer(
  ({ store }) => {
    const { loadFilters, reset, filters, filterKey, setFilter } = store

    useEffect(() => {
      loadFilters()

      return () => {
        reset()
      }
    }, [])

    return (
      <Select
        type={'default'}
        value={filterKey}
        items={getFiltersItems(filters, filterKey)}
        onSelectValue={setFilter}
        btnProps={{
          typeBtn: 'text',
        }}
        dropdownProps={{
          withSearch: false,
          margin: 4,
          ariaLabel: 'SelectField',
          PopperProps: {
            modifiers: [availableHeight('DropdownList_Items')],
          },
        }}
      />
    )
  }
)
